// teachers/repair-requests
import React from 'react';
import View from 'src/pages/coming-soon';
import AppRender from 'src/routes/app-render';

const Page = () => {
  return (
    <AppRender>
      <View message={'Đề xuất các hạng mục cần bảo dưỡng, thay thế'} />
    </AppRender>
  );
};

export default Page;
